import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import { Environment } from 'shared/environments';

const config: AxiosRequestConfig = {
  baseURL: Environment.API_URL_BASE,
  withCredentials: true,
};

export const api: AxiosInstance = axios.create(config);

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.message === 'Network Error') toast.error("Desculpem-nos o transtorno, estamos em obras para melhor atendê-los!");

    if (error.response?.status === 401) window.dispatchEvent(new CustomEvent('p3m:sessionExpired'));

    if (error.response?.status === 404) toast.error(error.message);

    return Promise.reject(error);
  },
);
